import React from "react";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Image from "next/image";

function ContactWrapper({
  children,
  heroImage = "/img/contact/sent.png",
  backgroundColor = "white",
}) {
  return (
    <section
      className="mw-1920 mx-auto"
      style={{ backgroundColor: backgroundColor }}>
      <section className="contact-success-section d-flex align-items-center section-padding-y">
        <Container className="contact-success-container">
          <Row className="w-100">
            <Col md={6} className="success-graphic">
              <Image
                src={heroImage}
                width={600}
                height={602}
                unoptimized={true}
              />
            </Col>
            <Col
              md={6}
              className="d-none d-md-flex align-items-center success-message">
              <div className="w-100 position-relative">{children}</div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="d-md-none">
        <Container>
          <Row>
            <Col>
              <div className="w-100 position-relative">{children}</div>
            </Col>
          </Row>
        </Container>
      </section>
    </section>
  );
}

export default ContactWrapper;
